/* eslint-disable no-new */
import Vue from 'vue'
import App from './App.vue'
import makeStore from './store'
import 'core-js/stable'

Vue.config.productionTip = false

const initQuestionnaires = () => {
  const questionnaires = document.querySelectorAll('.questionnaire, #questionnaire')

  for (const questionnaire of questionnaires) {
    const questionnaireId = questionnaire.getAttribute('data-questionnaire-id')
    new Vue({
      store: makeStore(),
      render: h => h(App, { props: { questionnaireId: questionnaireId } })
    }).$mount(questionnaire)
  }
}

initQuestionnaires()

document.addEventListener('init-questionnaires', initQuestionnaires)
